import React from 'react';
import Helmet from 'react-helmet';
import { useConfigContext } from '../../../config-context';
export var SearchResultsSEO = function () {
    // tslint:disable-next-line: react-hooks-nesting
    var metaTagsAggregator = useConfigContext().metaTagsAggregator;
    if (metaTagsAggregator) {
        metaTagsAggregator.push("<meta data-meta-tags-aggregator=\"true\" name=\"robots\" content=\"noindex, nofollow\" />");
    }
    return (React.createElement(Helmet, null,
        React.createElement("meta", { name: "robots", content: "noindex, nofollow" })));
};
//# sourceMappingURL=search-result-seo.js.map